<template>
  <div class="page page-with-bg login-page">
    <div class="page-form-wrap">
      <div class="page-form-header">
        <h1>My profile</h1>
      </div>
      <div class="page-form-content">
        <b-form @submit.prevent="submit">
          <validation-summary :errors="errors"></validation-summary>

          <div class="row">
            <div class="col-12 col-md-6">
              <v-form-group :validator="$v.user.firstName"
                            label="First Name">
                <b-form-input slot-scope="{ attrs, listeners }"
                              v-bind="attrs"
                              v-on="listeners"
                              v-model="user.firstName"
                              placeholder="First Name" />
              </v-form-group>
            </div>
            <div class="col-12 col-md-6">
              <v-form-group :validator="$v.user.lastName"
                            label="Last Name">
                <b-form-input slot-scope="{ attrs, listeners }"
                              v-bind="attrs"
                              v-on="listeners"
                              v-model="user.lastName"
                              placeholder="Last Name" />
              </v-form-group>
            </div>
          </div>
          <v-form-group :validator="$v.user.phoneNumber"
                        label="Phone Number">
            <form-input-formatted type="phone"
                                  id="phone"
                                  v-model="user.phoneNumber"
                                  placeholder="Phone Number" />
          </v-form-group>

          <b-form-group class="form-buttons">
            <b-button size="lg" variant="success" type="submit">Save</b-button>
          </b-form-group>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
  import { required } from "vuelidate/lib/validators";
  import formMixin from "mixins/form-mixin";

  import { createNamespacedHelpers } from 'vuex';
  const { mapState, mapActions } = createNamespacedHelpers('user');

  import { usaStates } from 'typed-usa-states';

  export default {
    mixins: [formMixin],

    data() {
      return {
        usaStates
      };
    },

    validations: {
      user: {
        firstName: {
          required
        },
        lastName: {
          required
        },
        phoneNumber: {
          required
        }
      }
    },

    computed: {
      ...mapState(["user"])
    },

    async created() {
      await this.getCurrentUser();
    },

    methods: {
      ...mapActions(["getCurrentUser", "update"]),

      async onSubmit() {
        await this.update();
        this.$root.successToast("Profile updated!");
      },
    }
  };
</script>
<style lang="scss" scoped>
  @import '@/styles/_mixins';

  .page {
    @include retina('/png/coffee.png');
  }
</style>